// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls-module__BuildControls__1lCkp","OrderButton":"BuildControls-module__OrderButton__2rQVu","enable":"BuildControls-module__enable__3jVZ7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.module.css
// module id = 108
// module chunks = 2